import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Media.css';

const Media = () => {
  const mediaHeroBackgroundRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (mediaHeroBackgroundRef.current) {
        const scrolled = window.pageYOffset;
        const parallax = scrolled * 0.5;
        mediaHeroBackgroundRef.current.style.transform = `translateY(${parallax}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="media">
      <section className="media-hero">
        <div 
          ref={mediaHeroBackgroundRef}
          className="media-hero-background"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/services_hero.png)`
          }}
        ></div>
        <div className="container">
          <h1>Media</h1>
          <p className="hero-description">
            Explore our latest news, press releases, and media resources.
          </p>
        </div>
      </section>

      <section className="media-content">
        <div
          className="media-content-background"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/topo_map.png)`
          }}
          aria-hidden="true"
        />
        <div className="container">
          <div className="media-section">
            <h2>Media Resources</h2>
            <p>
              Welcome to the UpNorth Impact media center. Here you'll find press releases, 
              news articles, and resources for media professionals.
            </p>
          </div>

          <div className="media-cta">
            <h2>Stay Connected</h2>
            <p>For media inquiries, please contact us.</p>
            <Link to="/contact" className="btn btn-primary btn-large">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Media;
